<template>
  <form
    name="revisionsForm"
    @submit.prevent="updateActiveContentItemVersion">
    <div
      class="page-tab-content-expand table revisions">
      <div class="thead">
        <div class="tr">
          <div class="th version text-right">Version</div>
          <div class="th modified">Modified</div>
          <div class="th content">Content</div>
        </div>
      </div>
      <div class="tbody">
        <div
          class="tr"
          :class="{
            'green lighten-4': revision.selected,
          }"
          v-for="revision in contentItemRevisions"
          :key="revision.version"
          @click="selectRevision(revision)">
          <div class="td version text-right">{{revision.version}}</div>
          <div class="td modified">
            {{revision.modifiedUtc | date}}<br>
            {{revision.modifiedUtc | time}}
          </div>
          <!-- Image -->
          <div v-if="type === 'image'" class="td content">
            <img
              v-if="revision.content"
              :src="revision.content"
            />
            <small
              v-else
              class="font-italic text--secondary">
              not defined
            </small>
          </div>
          <!-- / Image -->

          <!-- Text -->
          <div
            v-else
            class="td content">
            <div
              v-if="revision.content">
              <!-- Color Content -->
              <div
                v-if= "contentItemInfo(revision.contentId).section === 'Colors'"
                class="content-content content-color">
                <div
                  :style="{
                    backgroundColor: revision.content,
                  }">
                </div>
              </div>
              <!-- / Color Content -->

              <!-- Non Color Content -->
              <div
                v-else
                v-html="revision.content">
              </div>
              <!-- / Non Color Content -->
            </div>

            <small
              v-else
              class="font-italic text--secondary">
              not defined
            </small>
          </div>
          <!-- / Text -->
        </div>
      </div>
    </div>

    <div class="page-buttons d-flex my-5">
      <v-btn
        type="submit"
        color="primary"
        :disabled="!selectedRevision">
        Revert to Selected Version
      </v-btn>

      <v-btn
        @click="goToContentList"
        type="button"
        color="primary"
        class="mr-auto order-first"
        outlined>
        Cancel
      </v-btn>
    </div>
  </form>
</template>

<script>
import ContentItemMixin from '../mixin.content-item';

export default {
  name: 'Revisions',
  props: ['type'],
  mixins: [
    ContentItemMixin,
  ],
};
</script>

<style lang="scss"></style>
